/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ms: NonNullable<unknown> }} Byoa_Test_OkInputs */

const en_byoa_test_ok = /** @type {(inputs: Byoa_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected (${i?.ms} ms).`)
};

const id_byoa_test_ok = /** @type {(inputs: Byoa_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berhasil tersambung (${i?.ms} ms).`)
};

/**
* | output |
* | --- |
* | "Connected ({ms} ms)." |
*
* @param {Byoa_Test_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_test_ok = /** @type {((inputs: Byoa_Test_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Test_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_test_ok(inputs)
	return en_byoa_test_ok(inputs)
});